export default __webpack_public_path__ + "0e3f672e05910533dd28a3230a80a48d.mp3";